import { Component, OnInit, ViewChild, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import { User } from '../_models/user';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from "angularx-social-login";
import { FormBuilder, Validators } from '@angular/forms';
import { ContactUsService } from "../contact-us/contact-us.service";
import { ReCaptchaV3Service } from 'ngx-captcha';
import { DamserviceService } from "./damservice.service";
import { Payment } from '../_models/payment';
import { UploadFilesService } from 'src/app/services/upload-files.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { Title, Meta } from '@angular/platform-browser';
import { OrganisationService } from "../create-organisation/organisation.service";
import { AlertService } from "../components/alert/alert.service";
import { InboxservicesService } from "../inboxarea/inboxservices.service";
import { SubscriptionService } from "../subscription/subscription.service";
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { webSocket, WebSocketSubject} from 'rxjs/webSocket';
import { GoogleAnalyticsService } from '../google-analytics.service';
import AOS from 'aos';

@Component({
  selector: 'app-dam',
  templateUrl: './dam.component.html',
  styleUrls: ['./dam.component.css'],
})
export class DamComponent implements OnInit {

  myWebSocket: WebSocketSubject<any> = webSocket('ws://localhost:8000');

  changeColor= [false, false, false];
  checkedId = -1;
  checkedTitle = -1;
  count: number = 0;
  fileText: string;

  currentUser: User;
  mobileView: boolean = false;
  txtValue:string = null;
  txtField: boolean = false;

  priceDetailsSection: boolean = false;
  mainDetailSection: boolean = false;

  radioYearly: boolean = true;
  radioMonthly: boolean = false;
  radioYear: boolean = true;
  radioMonth: boolean = false;
  selectedMembership: any = null;
  selectedMembershipBuyNow: any = null;
  payment: Payment;
  public isIndia: boolean = false;
  returnUrl: any;
  strikeCheckout:any = null;
  memberships = [];
  userName: string;
  userEmail: string;
  svgCheck: boolean = false;
  pngCheck: boolean = false;
  jpgCheck: boolean = false;
  downloadDelete:boolean = false;
  showDot: boolean = false;
  createBoardLoader: boolean = false;
  createSubBoardLoader: boolean = false;

  letsTalkForm = this.fb.group({
    name: ['', Validators.required],
    lname: ['', Validators.required],
    message: ['Enterprise plan query DAM(inside)', Validators.required],
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
  });

  commentForm = this.fb.group({
    comment: ['', Validators.required],
  });

  replyForm = this.fb.group({
    replyMessage: ['', Validators.required],
  });

  mainMsgForm = this.fb.group({
    mainmessage: ['', Validators.required],
  });

  tagsForm = this.fb.group({
    edittags: ['', Validators.required],
  });

  submitted: Boolean = false;

  mobileViewSection: boolean = false;
  shimmerSection: boolean = true;
  mainSection: boolean = true;
  timelineSection: boolean = false;
  tableViewSection: boolean = false;
  tableViewData: boolean = false;
  folderViewSection: boolean = false;
  folderViewData: boolean = false;
  searchImageslistSection: boolean = false;
  hideDialogSection: boolean = true;
  showAccessLevel: boolean = false;
  showTagField: boolean = false;
  showChatLoader: boolean = false;
  timeLineClicked: boolean = false;
  tableViewClicked: boolean = false;
  folderViewClicked: boolean = false;
  mainViewClicked: boolean = false;

  boardname: string = '';
  editBoardId: any;
  friendemail: string = '';
  boardHeading: string = '';
  createBoardErrorMsg: string;
  createSubBoardErrorMsg: string;
  showCreateBoardError: Boolean = false;
  showCreateBoardErrorSub: Boolean = false;
  editBoardTitle: string = '';
  boardId: any;
  userPic: any;
  workspaceId: any;
  searchTextSet: any;
  boards = [];
  welcomeBoards = [];
  workspaces = [];
  workspaceName: string;
  userRole: string;
  dataImages: any = [];
  finalImages = [];
  urls=[];
  sortedImagesList = [];
  imagesIdList: Array<{index: any; id: any, title: string}> = [];
  imagesIds: Array<{id: any}> = [];
  moveFromSearch: any;
  moveBoards = [];
  moveBoardId: any;
  searchedBoards = [];
  moveImagesStyle = "none";
  offersStyle = "none";
  cashbackOffersStyle = "none";
  dialogId: any;
  offerButtonTxt: any;
  offerTitleTxt: any;
  offerDescriptionTxt: any;
  offerDetailsDescriptionTxt: any;
  dataRequiredStyle = "none";
  dataRequired: any = "100GB";
  totalDataAmount: any = "$100";
  boardSearchKeyword: string;
  showSearchBoardList: boolean = false;
  showSearchBoardOlderList: boolean = true;
  openBoardList: boolean = false;
  asssetsIdsList = [];
  imageSelected:boolean = false;
  notifications = [];
  dateValue: [];
  openNotifications: boolean = false;
  notificationMsg: string;
  showLoader: boolean = false;
  showSearchNextIcon: boolean = true;
  showSearchPreviosIcon: boolean = true;
  showNextIcon: boolean = true;
  showPreviosIcon: boolean = true;
  shimmerFolderSection: boolean = true;

  boardRenameStyle = "none";
  boardCurrentName: any;
  boardNewName: any;
  editNameBoardId: any;

  selectedFiles: FileList;
  progressInfos = [];
  message = '';

  fileInfos: [];
  tagsList: any;
  imagesExtension: [];
  imagesList = [];
  totalIllusCount: any;
  fileTypeText: string = '';
  boardImages: any;
  currentIllus: any;
  currentIllusPosition: any;
  currentSearchIllusPosition: any;
  currentBoard: any;
  isSVG: boolean = true;
  searchText: string = '';
  searchTerms: string[] = [];
  createBoardText: string = '';
  addTagText: string = '';
  addedTag: string;
  addedTagList: Array<{tags: string}> = [];
  searchData: string = '';
  plusButton: boolean = true;
  tagFieldArea: boolean = false;
  totalSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  consumedSpaceAllowed: any;
  planName: string;
  ownerEmail: String;
  ownerName: String;
  displayStyle = "none";
  shareStyle = "none";
  deleteStyle = "none";
  deleteBoardStyle = "none";
  deleteProcessStyle = "none";
  shareLinkStyle = "none";
  createSubBoardStyle = "none";
  shareImageLink: any;
  renameImageLink: any;
  editTagsImageLink: any;
  editTagsImageFormats: any;
  editTagsName: any;
  editTagsList: string[] = [];
  assetEditTagsStyle = "none";
  showEditTagsLoader: boolean = false;
  editTagsError: any;
  fromWhichSection: any;
  deleteBoardId: any;
  deleteBoardName: string;
  createSubBoardId: any;
  createSubBoardMainBoardName: string;
  boardIdsList = [];
  suggestedTags = [];
  dataSpaceList = [];
  isFav: boolean = false;
  isShowShareLinkGenerated: boolean = true;
  isHideShareLinkGenerated: boolean = false;
  sendSuccessful: boolean = false;
  sendSuccessfulErrorMsg: boolean = false;
  sendSuccessfulErrorMessage: string;
  successfullMessage: string;
  showEditImageName: boolean = false;
  hideEditImageName: boolean = true;
  showEditFavImageName: boolean = false;
  hideEditFavImageName: boolean = true;
  imageNameEdit: string = '';
  favImageNameEdit: string = '';
  imageHeading: string = '';
  favImageHeading: string = '';
  isEditName: boolean = false;
  imageNameTitle: any;
  isEditFavName: boolean = false;
  favImageNameTitle: any;
  workspaceCountAllowed: any;
  totalWorkspaceCreated: any;
  planId: any;
  shareableLink: string;
  showAssetsRenameLoader: Boolean = false;

  showCreateWorkspaceLoader: boolean = false;
  showLeaveLoader: boolean = false;
  showDeleteLeaveLoader: boolean = false;
  showDialogDeleteLeaveLoader: boolean = false;
  showLinkCopied: boolean = false;
  imageDownloadFormat: any;
  imageDownloadShowFormat: any;
  showDownloadLoader: boolean = false;
  showMainDownloadLoader: boolean = false;
  showDownloadDialog: boolean = false;
  showTopRightLoader: boolean = false;
  showLoaderBoardsList: boolean = false;
  public selectedFormatIndex;
  imageFormats = [];

  commentId: any;
  commentMsg: any;
  replyMsg: any;
  editComment: any;
  commentsList = [];
  noComments: any;
  openEditBox: boolean = false;
  public textArea: string = '';
  public replyArea: string = '';

  showUsersListDialog: boolean = false;
  showUsersListReplyDialog: boolean = false;
  userSelectedForTag: boolean = false;
  userSelectedForReplyTag: boolean = false;
  selectedUserIdForTag: any;
  selectedUserNameForTag: any;
  usersList = [];

  public index;

  fromSectionDialog: any;

  isShowLoadingStatus: boolean = false;
  isShowLoadingStatusDone: boolean = false;
  selectedVersion: any;
  uploadedFileName: string;
  uploadOptionsStyle = "none";
  uploadVersionStyle = "none";
  progressPecentage: any;
  public replaceAsset: boolean = true;
  showSmallImg: boolean = false;

  sharedToken: any;
  fromAssets: boolean = false;
  allowDownloads: any;
  showComments: any;
  allowComments: any;
  allowDownloadSelected: boolean = true;
  showCommentSelected: boolean = false;
  allowCommentingSelected: boolean = false;
  expiryLinkIn: any = "f";

  renameErrorMsg: string;
  renameBoardMsg: string;
  assetRenameStyle = "none";
  assetCurrentId: any;
  assetCurrentName: any;
  assetBoardId: any;
  assetNewName: any;
  renameBoardId: any;
  showRenameLoader: boolean = false;

  isNestedSelected: boolean = true;
  isTableSelected: boolean = false;
  isTimelineSelected: boolean = false;
  isFolderSelected: boolean = false;

  public siteKey?: string = '6Lf59_gUAAAAAEJNHrHp1Vdd1LaG1epuOF62yj80';
  public token?: string;
  public siteKeyV2: string = "6Lf4BvkUAAAAAKreyepy8vMm4ttzZtXIY_0xVJ0O";
  type: string = "checkbox";

  public selectedIndex;

  createPrivateSharedWorkspaceStyle = "none";
  createWorkspaceStyle = "none";
  isShowCreateWorkspaceError: boolean = false
  createWorkspaceErrorMessage: string;
  isShowCreateLoginWorkspaceError: boolean = false
  createWorkspaceLoginErrorMessage: string;

  creatwWorkspace = this.fb.group({
    message: ['', Validators.required],
  });

  createBoardForm = this.fb.group({
    message: ['', Validators.required],
  });

  createSubBoardForm = this.fb.group({
    message: ['', Validators.required],
  });

  renameBoard = this.fb.group({
    boardname: ['', Validators.required],
  });

  isMobile: any;

  offersForm = this.fb.group({
    fullname: ['', Validators.required],
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
  });

  seoTitle = 'All Boards | Workspace | Crafttor ';

  userFullName: any;
  userFullEmail: any;

  constructor(
    private cdr: ChangeDetectorRef,
    private contacUsService: ContactUsService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private modalService: NgbModal,
    private authService: AuthService,
    private damService: DamserviceService,
    private uploadService: UploadFilesService,
    private titleService: Title,
    private metaTagService: Meta,
    private organisationService: OrganisationService,
    private alert: AlertService,
    private inboxService: InboxservicesService,
    private subscriptionService: SubscriptionService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    this.myWebSocket.subscribe(
      msg => console.log('message received: ' + msg),
      // Called whenever there is a message from the server
      err => console.log(err),
      // Called if WebSocket API signals some kind of error
      () => console.log('complete')
      // Called when connection is closed (for whatever reason)
   );
  }

  sendMessageToServer() {
    if (this.myWebSocket) {
      const payload = {
        token: this.currentUser.token
    };
      this.myWebSocket.next(payload);
    }
  }

  // @HostBinding('class.nav-bar-toggle') someField: boolean = false;
  @ViewChild('imgTimeLineModal') imgTimeLineModal;
  @ViewChild('imgSearchModal') imgSearchModal;
  @ViewChild('shareModal') shareModal;
  @ViewChild('letsTalk') letsTalk;
  @ViewChild('thankyou') thankyou;
  @ViewChild('paymentSuccess') paymentSuccess;
  @ViewChildren("checkboxes") checkboxes;

  ngOnInit(): void {
    this.titleService.setTitle(this.seoTitle);
    this.metaTagService.addTags([
      { name: 'description', content: 'Get access to your digital assets and manage them in a way you want. We keep all your assets secure and smooth in our workspace.'},
      { name: 'keywords', content: 'dam, DAM, workspace, Crafttor Workspace, workspace crafttor, upload illustrations, upload premium illustration, upload images, upload svg images' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    AOS.init();

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (this.isMobile) {
      this.mobileViewSection = true;
      this.mainSection = false;
      this.timelineSection = false;
      this.tableViewSection = false;
      this.tableViewData = false;
      this.searchImageslistSection = false;
      this.folderViewSection = false;
      this.folderViewData = false;
      this.mobileView = true;
    }else{
      this.mobileViewSection = false;
      this.mainSection = true;
      this.timelineSection = false;
      this.tableViewSection = false;
      this.folderViewSection = false;
      this.folderViewData = false;
      this.tableViewData = false;
      this.searchImageslistSection = false;
      this.mobileView = false;
      this.mainViewClicked = true;
    }

    if (this.currentUser) {
      this.getWorkspaceDetails();
      this.getUserPic();
      this.showOfferDialogToUsers();
    } else {
      this.router.navigate(['/login']);
    }

    this.userFullName = this.currentUser.firstName + " " + this.currentUser.lastName;
    this.userFullEmail = this.currentUser.email;


    this.fileTypeText = 'SVG';

    // this.suggestedTags.push("3D");
    // this.suggestedTags.push("illustration");
    // this.suggestedTags.push("vector");
    // this.suggestedTags.push("woman");
    // this.suggestedTags.push("man");
    // this.suggestedTags.push("product");
    // this.suggestedTags.push("laptop");
    // this.suggestedTags.push("mobile");

    this.imageFormats.push("PNG");
    this.imageFormats.push("JPEG");
    // this.imageFormats.push("gif");
    // this.imageFormats.push("raw");
    this.imageFormats.push("TIFF");
    this.imageFormats.push("WEBP");

    this.dataSpaceList.push("100GB");
    this.dataSpaceList.push("200GB");
    this.dataSpaceList.push("400GB");
    this.dataSpaceList.push("500GB");
    this.dataSpaceList.push("1TB");
    this.dataSpaceList.push("4TB");

    this.searchTerms = [];
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.getCurrentUserData(this.workspaceId);
    this.getFavImagesList(this.workspaceId);
    // this.getWelcomeBoardsList(this.workspaceId);
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  selectWorkspace(id: any, title: string, userRole: string){
    this.workspaceName = title;
    this.workspaceId = id;
    this.getCurrentUserData(this.workspaceId);
    this.getFavImagesList(this.workspaceId);
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: id,
      workspaceName: title, userRole: userRole }));
      this.titleService.setTitle(title+" | All Boards | Workspace | Crafttor");
      this.selectedIndex = -1;
      this.downloadDelete = false;
      this.imagesIdList = [];
      this.changeColor = [];
      this.imageSelected = false;
      this.searchText = '';
      this.timelineSection = false;
      this.searchImageslistSection = false;
      this.tableViewSection = false;
      this.tableViewData = false;
      this.folderViewSection = false;
      this.folderViewData = false;
      this.isTimelineSelected = false;
      this.isTableSelected = false;
      this.isNestedSelected = true;
      this.isFolderSelected = false;
      this.mainSection = true;
      this.getBoardsListing(this.workspaceId);
  }

  getCurrentUserData(workspaceId: any) {
    this.showTopRightLoader = true;
    this.damService.getCurrentUserData(workspaceId).subscribe((data: any) => {
      this.userRole = data.role;
      this.listWorkspace();
      this.getBoardsListing(this.workspaceId);
    },
    (error) => {
      if (this.currentUser) {
        if(error.status == 500){
          // this.router.navigate(['/maintenance']);
        } else {

        }
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  listWorkspace(){
    if (this.currentUser) {
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          if (this.isMobile) {
            this.mobileViewSection = true;
            this.mainSection = false;
            this.timelineSection = false;
            this.tableViewSection = false;
            this.tableViewData = false;
            this.searchImageslistSection = false;
            this.mobileView = true;
          }else{
            this.mobileViewSection = false;
            this.mainSection = true;
            this.timelineSection = false;
            this.tableViewSection = false;
            this.tableViewData = false;
            this.folderViewSection = false;
            this.folderViewData = false;
            this.searchImageslistSection = false;
            this.mobileView = false;
          }
          this.workspaces = data;
          this.ownerListApi();
        } else{
            localStorage.setItem('workspaceCreationScreenDetails', JSON.stringify({ screenId: 1}));
            this.router.navigate(['/create-workspace']);
          }
        });
      } else {
        this.router.navigate(['/login']);
      }
  }

  onSelect(e){
    if(e.target.files){
      for(let i=0; i<File.length; i++){
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[i]);
        reader.onload=(events:any)=>{
          this.urls.push(events.target.result)
        }
      }
    }
  }

  getBoardsListing(workspaceId: any){
    this.showLoaderBoardsList = true;
    this.damService.getBoardsList(workspaceId).subscribe((data: any) => {
      if(data.length == 0){
        this.openPopup();
      }
      this.shimmerFolderSection = false;
      this.shimmerSection = false;
      this.showTopRightLoader = false;
      this.boards = data;
      this.showLoaderBoardsList = false;
    });
  }

  getTimelineImagesList() {
    this.showTopRightLoader = true;
    this.damService.getSortedImagesList(this.workspaceId).subscribe((data: any) => {
      this.showTopRightLoader = false;
      this.sortedImagesList = data;
    },(error: any) => {
      if(error.status == 400){
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  getSortedImagesList() {
    console.log("Clicked table line views");
    this.mobileViewSection = false;
    this.mainSection = false;
    this.timelineSection = false;
    this.searchImageslistSection = false;
    this.tableViewSection = true;
    this.showTopRightLoader = true;
    this.damService.getSortedImagesList(this.workspaceId).subscribe((data: any) => {
      this.tableViewData = true;
      this.showTopRightLoader = false;
      this.sortedImagesList = data;
    },(error: any) => {
      if(error.status == 400){
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  // onSubmit() {
  //   if(this.searchText != '') {
  //     this.searchImages(this.searchText);
  //   }
  // }

  onCreateBoard(boardNames: any) {
    this.createBoardDialog(boardNames);
  }


  createBoardDialog(createBoardTextName: string){
    this.showCreateBoardError = false;
    if(this.createBoardForm.valid) {
      this.createBoardLoader = true;
      this.damService.createNewBoard(this.workspaceId, createBoardTextName).subscribe((data: any) => {
        this.createBoardLoader = false;
        this.createBoardForm.reset();
        this.boardHeading = data.title;
        this.boardId = data.id;
        this.currentBoard = data.id;
        this.displayStyle = "none";
        this.boardlistClickNew(this.boardHeading, this.boardId);
      },(error: any) => {
        if(error.status == 400){
          this.createBoardLoader = false;
          this.showCreateBoardError = true;
          this.createBoardErrorMsg = error.error.title;
        } else {
          this.showCreateBoardError = true;
          this.createBoardErrorMsg = error.error.message;
        }
     });
    }
  }

  selectFilter(e, searchTxt: string){
    if(e.target.checked){
      this.filterImages(this.boardId, searchTxt);
    }
  }

  filterImages(boardId: any, searchText: string){
    this.googleAnalyticsService.event('images_filter_dam_screen_click', 'images_filter_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    this.damService.filterImage(this.workspaceId, boardId, searchText).subscribe((data: any) => {
      this.fileInfos = data['results'];
      this.totalIllusCount = data['results'].length;
    });
  }

  clearFilter(){
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
    this.damService.filterImage(this.workspaceId, this.boardId, "").subscribe((data: any) => {
      this.fileInfos = data['results'];
      this.totalIllusCount = data['results'].length;
    });
  }

  mainClick(){
    this.googleAnalyticsService.event('main_view_dam_screen_click', 'main_view_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    this.isTimelineSelected = false;
    this.isTableSelected = false;
    this.isFolderSelected = false
    this.isNestedSelected = true;
    this.searchTerms = [];
    this.titleService.setTitle("All Boards | Workspace | Crafttor");
    this.selectedIndex = -1;
    this.downloadDelete = false;
    this.imagesIdList = [];
    this.changeColor = [];
    this.imageSelected = false;
    this.searchText = '';
    this.timelineSection = false;
    this.searchImageslistSection = false;
    this.tableViewSection = false;
    this.tableViewSection = false;
    this.tableViewData = false;
    this.folderViewSection = false;
    this.folderViewData = false;
    this.mainSection = true;
    this.mainViewClicked = true;
    this.mobileViewSection = false;
    this.getBoardsListing(this.workspaceId);
  }

  timelineClick(){
    this.googleAnalyticsService.event('timeline_view_dam_screen_click', 'timeline_view_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    this.isTimelineSelected = true;
    this.isTableSelected = false;
    this.isNestedSelected = false;
    this.isFolderSelected = false;
    this.selectedIndex = -1;
    this.mainSection = false;
    this.mobileViewSection = false;
    this.searchImageslistSection = false;
    this.tableViewData = false;
    this.tableViewSection = false;
    this.folderViewSection = false;
    this.folderViewData = false;
    this.timelineSection = true;
    this.timeLineClicked = true;
    if(this.tableViewClicked) {

    } else {
      this.getTimelineImagesList();
    }
  }

  tableViewClick() {
    this.googleAnalyticsService.event('table_view_dam_screen_click', 'table_view_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    this.tableViewClicked = true;
    this.isTimelineSelected = false;
    this.isFolderSelected = false;
    this.isTableSelected = true;
    this.isNestedSelected = false;
    this.folderViewSection = false;
    this.folderViewData = false;
    if(this.timeLineClicked) {
      this.mobileViewSection = false;
      this.mainSection = false;
      this.timelineSection = false;
      this.searchImageslistSection = false;
      this.tableViewSection = true;
      this.tableViewData = true;
    } else {
      this.getSortedImagesList();
    }
  }

  folderViewClick() {
    this.googleAnalyticsService.event('folder_view_dam_screen_click', 'folder_view_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    this.isTimelineSelected = false;
    this.isTableSelected = false;
    this.isNestedSelected = false;
    this.isFolderSelected = true;
    this.searchTerms = [];
    this.titleService.setTitle("All Boards | Workspace | Crafttor");
    this.selectedIndex = -1;
    this.downloadDelete = false;
    this.imagesIdList = [];
    this.changeColor = [];
    this.imageSelected = false;
    this.searchText = '';
    this.timelineSection = false;
    this.searchImageslistSection = false;
    this.tableViewSection = false;
    this.tableViewSection = false;
    this.tableViewData = false;
    this.folderViewSection = true;
    this.folderViewData = true;
    this.mainSection = false;
    this.mobileViewSection = false;
    this.folderViewClicked = true;
    if(this.mainViewClicked) {

    } else {
      this.getBoardsListing(this.workspaceId);
    }
  }

  peopleClick(){
    this.googleAnalyticsService.event('people_dam_screen_click', 'people_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/people']);
  }

  editBoardClickNew(boardTitle: string, boardId: any){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
      console.log("Board ID coming : "+boardId);
    localStorage.setItem('editBoardDetails', JSON.stringify({ boardId: boardId, boardTitle: boardTitle}));
    this.router.navigate(['/dam/edit-board']);
  }

  archiveClick() {
    this.googleAnalyticsService.event('trash_dam_screen_click', 'trash_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['dam/trash']);
  }

  inboxClick(){
    this.googleAnalyticsService.event('inbox_dam_screen_click', 'inbox_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['dam/inbox']);
  }

  settingsClick(){
    this.googleAnalyticsService.event('settings_dam_screen_click', 'settings_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/settings']);
  }

  personalClick(){
    this.googleAnalyticsService.event('my_content_hub_dam_screen_click', 'my_content_hub_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/personal']);
  }

  newBoardClick(){
    this.googleAnalyticsService.event('create_new_board_dam_screen_click', 'create_new_board_click', this.currentUser.firstName +" "+this.currentUser.lastName);
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/create-board']);
  }

  getName(fullEmail: string) {
    return fullEmail.split(' ').map(n => n[0]).join('').toUpperCase();
  }

  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }

  boardlistClickNew(boardName: string, boardId: any){
    localStorage.setItem('boardDetails', JSON.stringify({ boardId: boardId, boardTitle: boardName}));
    this.router.navigate(['/dam/'+boardName]);
  }

  subBoardlistClick(mainBoard: string, boardName: string, boardId: any) {
    console.log("Get board name : "+mainBoard);
    localStorage.setItem('boardDetails', JSON.stringify({ boardId: boardId, boardTitle: boardName}));
    this.router.navigate(['/dam/' + boardName]);
  }

  closeDownloadDialog(boardId: any){
    this.showSmallImg = false;
    this.showDownloadDialog = false;
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
    this.isFav = false;
    this.addedTagList = [];
    this.getImagesList(boardId);
    // this.reStartListing();
  }

  getImagesList(boardId: any){
    this.uploadService.getFiles(this.workspaceId, boardId).subscribe((data: any) => {
      this.fileInfos = data['results'];
      this.totalIllusCount = data['results'].length;
      this.imageExtensionApi();
    });
  }

  closeTimelineDialog(boardId: any){
    this.imageDownloadShowFormat = "PNG";
    this.imageDownloadFormat = 'png';
    this.showSmallImg = false;
    this.showDownloadDialog = false;
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
    this.isFav = false;
    this.addedTagList = [];
    if(this.fromSectionDialog == 'timeline' || this.editNameDialogCloseScreen == '') {
      this.timelineClick();
    } else if(this.fromSectionDialog == 'table' || this.editNameDialogCloseScreen == 'regularDialog') {
      this.tableViewClick();
    }
    this.editNameDialogCloseScreen == '';
    this.fromSectionDialog == '';
  }

  closeDialogDownload(){
    this.showSmallImg = false;
    this.showDownloadDialog = false;
    this.isFav = false;
    this.addedTagList = [];
    // this.searchImages(this.searchText);
  }

  showTagFieldClick(){
    this.showTagField = true;
  }

  hideDialogClick(){
    if(this.hideDialogSection){
      this.hideDialogSection = false;
    }else{
      this.hideDialogSection = true;
    }
  }

  showAccessLevelClick(){
    this.showAccessLevel = true;
  }

  openShareDialog(modal){
      this.shareModal = this.modalService.open(modal, { centered: true, windowClass: 'svg-share-input ' });
  }

  openImgSearchDialog(modal, imgName: string, currentImgPos: any,
    currentVersion: any, boardId: any, currentAssetId: any){
      this.suggestedTags = [];
      this.getSuggestedTags(boardId, currentAssetId);
      this.boardId = boardId;
      this.selectedVersion = currentVersion;
      this.isEditFavName = false;
      this.addTagText = '';
      this.plusButton = true;
      this.tagFieldArea = false;
      this.imageHeading = imgName;
      this.favImageHeading = imgName;
      this.hideEditImageName = true;
      this.hideEditFavImageName = true;
      this.imageNameTitle = imgName;
      this.selectedFormatIndex = 0;
      this.imageDownloadShowFormat = "PNG";
      this.imageDownloadFormat = 'png';
      this.currentSearchIllusPosition = currentImgPos;
      if(currentImgPos == this.imagesList.length-1) {
        this.showSearchNextIcon = false;
        this.showSearchPreviosIcon = true;
      } else if(currentImgPos == 0){
        this.showSearchPreviosIcon = false;
        this.showSearchNextIcon = true;
      } else {
        this.showSearchPreviosIcon = true;
        this.showSearchNextIcon = true;
      }
      this.imgSearchModal = this.modalService.open(modal, { centered: true, windowClass: 'svg-modal ' });
  }

  openTimeLineDialog(modal, currentVersion: any, currentImgPos: any,
    fromSectionDialog: any, boardId: any, currentAssetId: any, imgName: string){
      this.suggestedTags = [];
      this.fromSectionDialog = fromSectionDialog;
      this.getSuggestedTags(boardId, currentAssetId);
      this.boardId = boardId;
      this.selectedVersion = currentVersion;
      this.imageHeading = imgName;
      this.favImageHeading = imgName;
      this.hideEditImageName = true;
      this.hideEditFavImageName = true;
      this.addTagText = '';
      this.plusButton = true;
      this.tagFieldArea = false;
      this.selectedFormatIndex = 0;
      this.imageDownloadShowFormat = "PNG";
      this.imageDownloadFormat = 'png';
      this.currentIllusPosition = currentImgPos;
      this.imgTimeLineModal = this.modalService.open(modal, { centered: true, windowClass: 'svg-modal ' });
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/home']);
  }

  newCrafttor(): void {
    this.openNewWorkspaceDialog();
  }

  showUpgradePlans(){
    window.scrollTo(0, 0);
    // this.selectedMembershipBuyNow = membership;
    if (this.currentUser) {
      this.googleAnalyticsService.event('upgrade_plan_dam_screen_click', 'upgrade_plan', this.currentUser.firstName +" "+this.currentUser.lastName);
      localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
        workspaceName: this.workspaceName, userRole: this.userRole }));
      this.router.navigate(['/dam/subscription']);
    }
  }

  openLetsTalkDialog(modal){
    this.googleAnalyticsService.event('open_lets_talk_dialog_dam_click', 'open_lets_talk_dialog', this.currentUser.firstName +" "+this.currentUser.lastName);
    this.letsTalk = this.modalService.open(modal, { centered: true, windowClass: 'sign-up ' });
  }

  openThankskDialog(modal){
    this.thankyou = this.modalService.open(modal, { centered: true, windowClass: 'thanks-popup ' });
  }

  deleteBoards(workspaceId: any, id: any, title: string){
    this.selectedIndex = -1;
    this.damService.archiveBoards(workspaceId, id).subscribe((data: any) => {
      this.timelineSection = false;
      this.searchImageslistSection = false;
      this.tableViewData = false;
      this.tableViewSection = false;
      this.folderViewSection = false;
      this.folderViewData = false;
      this.mainSection = true;
      this.mobileViewSection = false;
      this.reStartListing();
    });
  }

  deleteFullBoards(title: string){
    this.selectedIndex = -1;
    this.damService.archiveBoards(this.workspaceId, this.boardId).subscribe((data: any) => {
      this.timelineSection = false;
      this.searchImageslistSection = false;
      this.tableViewData = false;
      this.tableViewSection = false;
      this.folderViewSection = false;
      this.folderViewData = false;
      this.mainSection = true;
      this.mobileViewSection = false;
      this.reStartListing();
    });
  }

  reStartListing(){
    this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
      this.boards = data;
    });
  }

  searchImages(searchText: string = ""){
    this.downloadDelete = false;
    this.imagesIdList = [];
    this.changeColor = [];
    this.imageSelected = false;
    this.searchTextSet = searchText;
    this.damService.searchImages(this.workspaceId, searchText).subscribe((data: any) => {
      this.imagesList = data.image;
      this.searchData = this.searchText;
      this.mobileViewSection = false;
      this.mainSection = false;
      this.timelineSection = false;
      this.tableViewData = false;
      this.tableViewSection = false;
      this.searchImageslistSection = true;
    });
  }

  selectFiles(event, boardHeading: string, boardId: any): void {
    this.progressInfos = [];

    const files = event.target.files;
    let isImage = true;

    for (let i = 0; i < files.length; i++) {
      if (files.item(i).type.match('image.*')) {
        continue;
      } else {
        isImage = false;
        alert('invalid format!');
        break;
      }
    }

    if (isImage) {
      this.selectedFiles = event.target.files;
      this.uploadFiles(boardHeading, boardId);
    } else {
      this.selectedFiles = undefined;
      event.srcElement.percentage = null;
    }
  }

  uploadFiles(boardHeading: string, boardId: any): void {
    this.message = '';

    for (let i = 0; i < this.selectedFiles.length; i++) {
      this.upload(i, this.selectedFiles[i], boardHeading, boardId);
    }
  }

  upload(idx, file, boardHeading: string, boardId: any): void {
    this.progressInfos[idx] = { value: 0, fileName: file.name };
    this.uploadService.upload(file, file.name, boardHeading, boardId, this.workspaceId).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progressInfos[idx].percentage = Math.round(100 * event.loaded / event.total);
        } else if (event instanceof HttpResponse) {
          // this.fileInfos = this.uploadService.getFiles(boardId);
          this.getImagesList(boardId);
        }
      },
      err => {
        this.progressInfos[idx].percentage = 0;
        this.message = 'Could not upload the file:' + file.name;
      });
    }

    downloadImage(currentImageId: any, titleImage: string, boardId: any): void {
      this.damService.downloadImages(this.workspaceId, boardId, currentImageId).subscribe((data: any) => {
        saveAs(data, titleImage)
      });
    }

    downloadMultipleImage(){
      for(let ids of this.imagesIdList){
         this.damService.downloadImages(this.workspaceId, this.boardId, ids.id).subscribe((data: any) => {
             saveAs(data, ids.title)
             this.imagesIdList = [];
             this.changeColor = [];
             this.imageSelected = false;
             this.downloadDelete = false;
             this.count = 0;
          });
      }
    }

    notificationsOpened() {
      this.openNotifications = true;
    }

    getNotifications() {
      this.showLoader = true;
      this.newNotification();
    }

    newNotification () {
      this.googleAnalyticsService.event('get_notifications_dam_screen_click', 'get_notifications_click', this.currentUser.firstName +" "+this.currentUser.lastName);
      this.damService.newNotifications(this.workspaceId).subscribe((data: any) => {
        this.notifications = data['notifcation'];
        this.showLoader = false;
      });
    }

    showDownloadDeleteButtons(ivalue: any, i: any, imageId: any, titles: string){
      this.shareImageLink = "";
      this.downloadDelete = true;
      this.imageSelected = true;
      if(ivalue == false){
        this.count--;
        if(this.count <= 1){
          this.fileText = 'file';
        }else{
          this.fileText = 'files';
        }
        // console.log("Removed index i : "+i);
        this.imagesIdList.splice(i, 1);
        // console.log("Removed index i : "+i);
      }else{
        this.count++;
        if(this.count <= 1){
          this.fileText = 'file';
        }else{
          this.fileText = 'files';
        }
        this.imagesIdList.push({index: i, id: imageId, title: titles})
      }
    }

    cancelImageSelection(){
      this.count = 0;
      this.imageSelected = false;
      this.downloadDelete = false;
      this.imagesIdList = [];
      this.changeColor = [];
    }

    showTagFieldData(){
      this.plusButton = false;
      this.tagFieldArea = true;
    }

    onSubmitTag(boardId: any){
      this.addTagsData(this.addTagText, boardId);
    }

    onSubmitSearchTag(boardId: any) {
      this.addSearchTagsData(this.addTagText, boardId);
    }

    addTagsData(addTagText: string, boardId: any){
      this.addTagText = '';
      this.plusButton = false;
      this.tagFieldArea = true;
      this.damService.addImageTags(this.workspaceId, boardId, this.currentIllus.id,
        addTagText).subscribe((data: any) => {
          this.addedTag = data.tag;
          this.addedTagList.push({tags: this.addedTag});
          this.getImagesList(this.boardId);
      });
    }

    addSearchTagsData(addTagText: string, boardId: any){
      this.addTagText = '';
      this.plusButton = false;
      this.tagFieldArea = true;
      this.damService.addImageTags(this.workspaceId, boardId, this.currentIllus.id,
        addTagText).subscribe((data: any) => {
          this.addedTag = data.tag;
          this.addedTagList.push({tags: this.addedTag});
          this.searchArrayImages(this.searchText, this.searchTerms);
      });
    }

    onSubmitSuggestedTag(tag: any, boardId: any){
      this.addSuggestedTagsData(tag, boardId);
    }

   addSuggestedTagsData(addTagText: string, boardId: any){
     this.addTagText = '';
     this.plusButton = true;
     this.tagFieldArea = false;
     this.damService.addImageTags(this.workspaceId, boardId, this.currentIllus.id,
       addTagText).subscribe((data: any) => {
         this.addedTag = data.tag;
         this.addedTagList.push({tags: this.addedTag});
         this.getImagesList(this.boardId);
     });
   }

   onSubmitSuggestedSearchTag(tag: any, boardId: any){
     this.addSuggestedSearchTagsData(tag, boardId);
   }

  addSuggestedSearchTagsData(addTagText: string, boardId: any){
    this.addTagText = '';
    this.plusButton = true;
    this.tagFieldArea = false;
    this.damService.addImageTags(this.workspaceId, boardId, this.currentIllus.id,
      addTagText).subscribe((data: any) => {
        this.addedTag = data.tag;
        this.addedTagList.push({tags: this.addedTag});
        this.searchArrayImages(this.searchText, this.searchTerms);
    });
  }

    deleteImageTags(title: string, i: any){
      this.damService.deleteImageTags(this.workspaceId, this.boardId, this.currentIllus.id, title).subscribe((data: any) => {
        this.currentIllus.tags.splice(i, 1);
        this.getImagesList(this.boardId);
      });
    }

    deleteImageTagsList(title: string, i: any){
      this.damService.deleteImageTags(this.workspaceId, this.boardId, this.currentIllus.id, title).subscribe((data: any) => {
        this.addedTagList.splice(i, 1);
        this.getImagesList(this.boardId);
      });
    }

    deleteSearchImageTags(title: string, i: any){
      this.damService.deleteImageTags(this.workspaceId, this.boardId, this.currentIllus.id, title).subscribe((data: any) => {
        this.currentIllus.tags.splice(i, 1);
        this.searchArrayImages(this.searchText, this.searchTerms);
      });
    }

    deleteSearchImageTagsList(title: string, i: any){
      this.damService.deleteImageTags(this.workspaceId, this.boardId, this.currentIllus.id, title).subscribe((data: any) => {
        this.addedTagList.splice(i, 1);
        this.searchArrayImages(this.searchText, this.searchTerms);
      });
    }

    ownerListApi(){
      this.damService.getOwnerList(this.workspaceId).subscribe((data: any) => {
        this.ownerEmail = data.email;
        this.planName = data.plan_title;
        this.ownerName = data.first_name + " " + data.last_name;
        this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000;
        this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000;
        this.consumedSpaceAllowed = data.current_dam_space/1000;
        this.planId = data.plan_id;
        this.workspaceCountAllowed = data.allowed_workspace;
        this.totalWorkspaceCreated = data.total_workspace_created;
      });
    }

    imageExtensionApi(){
      this.damService.imagesExtension(this.workspaceId, this.boardId).subscribe((data: any) => {
        this.imagesExtension = data['image_formats'];
      });
    }

   openPopup() {
     this.displayStyle = "block";
   }

   closePopup() {
    this.displayStyle = "none";
  }

  openShareLinkStyle(imgId: any, imgLink: any) {
    this.fromAssets = true;
    this.shareImageLink = imgLink;
    this.hitShareAssetsApi(imgId);
  }

  hitShareAssetsApi(imgId: any) {
    this.subscriptionService.hitShare(this.workspaceId, this.boardId, imgId, "").subscribe((data) => {
      this.shareableLink = data.link;
      this.sharedToken = data.token;
      this.shareLinkStyle = "block";
      this.hideContent();
    },(error: any) => {
      if(error.status == 400){
        this.hideContent();
        this.alert.error(error.error.message)
      } else {
        this.hideContent();
        this.alert.error(error.error.message)
      }
   });
  }

  closeShareLinkStyle() {
    this.imagesIds = [];
    this.shareLinkStyle = "none";
  }

  openPopupShare(imgId: any) {
    this.fromAssets = true;
    this.shareStyle = "block";
    this.hitSharePopUpApi(imgId);
  }

  hitSharePopUpApi(imgId: any) {
    this.subscriptionService.hitShare(this.workspaceId, this.boardId, imgId, "").subscribe((data) => {
      this.shareableLink = data.link;
      this.sharedToken = data.token;
      this.hideContent();
    },(error: any) => {
      if(error.status == 400){
        this.hideContent();
        this.alert.error(error.error.message)
      } else {
        this.hideContent();
        this.alert.error(error.error.message)
      }
   });
  }

  closePopupShare() {
    this.imagesIds = [];
    this.fromAssets = false;
    this.shareStyle = "none";
 }

  openDeleteDialog(){
    this.deleteStyle = "block";
  }

  closeDeleteDialog(){
    this.deleteStyle = "none";
  }

  addFavouriteImage(imageId: any){
    this.damService.addFavouriteImages(this.workspaceId, imageId).subscribe((data: any) => {
      this.isFav = true;
      this.showEditImageName = false;
      this.showEditFavImageName = false;
    });
    this.getFavImagesList(this.workspaceId);
  }

  addSearchFavouriteImage(imageId: any, imageNameTitle: any, fromPos: any, fromWhichSection: any){
    this.showTopRightLoader = true;
    this.damService.addFavouriteImages(this.workspaceId, imageId).subscribe((data: any) => {
      if(fromPos == true) {
        this.damService.searchImagesArray(this.workspaceId, this.searchTerms).subscribe((data: any) => {
          this.searchText = "";
          this.showTopRightLoader = false;
          this.imagesList = data.image;
          this.searchData = '' + this.searchTextSet;
          this.mobileViewSection = false;
          this.mainSection = false;
          this.tableViewSection = false;
          this.tableViewData = false;
          this.timelineSection = false;
          this.searchImageslistSection = true;
          for(var i = 0 ; i < this.imagesList.length ; i++) {
            this.currentIllus = this.imagesList[this.currentSearchIllusPosition];
          }
        });
      } else {
        if(fromWhichSection == 'timeline') {
          this.damService.getSortedImagesList(this.workspaceId).subscribe((data: any) => {
            this.showTopRightLoader = false;
            this.sortedImagesList = data;
            this.mobileViewSection = false;
            this.mainSection = false;
            this.timelineSection = true;
            this.tableViewSection = false;
            this.tableViewData = false;
            this.searchImageslistSection = false;
            for(var i = 0 ; i < this.sortedImagesList.length ; i++) {
              this.currentIllus = this.sortedImagesList[this.currentIllusPosition];
            }
            this.showTopRightLoader = false;
          });
        } else if(fromWhichSection == 'search') {
          this.showTopRightLoader = false;
          this.searchArrayImages(this.searchText, this.searchTerms);
        } else if(fromWhichSection == 'table') {
          this.showTopRightLoader = false;
          this.getSortedImagesList();
        }
        this.getFavImagesList(this.workspaceId);
      }
    });
  }

  openDeleteBoardShare(boardId: any, boardName: string) {
    this.deleteBoardId = boardId;
    this.deleteBoardName = boardName;
    this.deleteBoardStyle = "block";
  }

  closeDeleteBoardShare() {
    this.showDialogDeleteLeaveLoader = false;
    this.deleteBoardStyle = "none";
  }

  openDeleteStyleBoard(){
    this.deleteProcessStyle = "block";
  }

  closeDeleteStyleBoard() {
   this.showLeaveLoader = false;
   this.deleteProcessStyle = "none";
  }

  deleteBoard(){
    this.showDialogDeleteLeaveLoader = true;
    this.selectedIndex = -1;
    this.damService.archiveBoards(this.workspaceId, this.deleteBoardId).subscribe((data: any) => {
      this.closeDeleteBoardShare();
      this.sendSuccessful = true;
      this.successfullMessage = this.deleteBoardName + " moved to trash";
      this.hideSuccesfullFunction();
      this.showDialogDeleteLeaveLoader = false;
      this.timelineSection = false;
      this.searchImageslistSection = false;
      this.tableViewSection = false;
      this.tableViewData = false;
      this.folderViewSection = false;
      this.folderViewData = false;
      this.mainSection = true;
      this.mobileViewSection = false;
      this.reStartListing();
    },
    (error) => {
      this.closeDeleteBoardShare();
      if(error.status == 403){
        this.showDialogDeleteLeaveLoader = false;
        this.alert.error(error.error.Message);
      } else if(error.status == 401){
        this.showDialogDeleteLeaveLoader = false;
        this.alert.error(error.error.Message);
      } else {
        this.showDialogDeleteLeaveLoader = false;
        this.alert.error(error.error.Message);
      }
   });
  }

  changeColors(i){
      this.selectedIndex = i;
  }

    verifyBoard(boardIds: any){
      this.sendSuccessful = false;
      this.showLeaveLoader = true;
      this.boardIdsList.push(boardIds);
      this.inboxService.verifyBoard(this.workspaceId, this.boardIdsList).subscribe((data: any) => {
        this.sendSuccessful = true;
        this.showLeaveLoader = false;
        this.successfullMessage = data.message;
        this.boardIdsList = [];
        this.hideSuccesfullFunction();
      },(error: any) => {
        if(error.status == 400){
          this.showLeaveLoader = false;
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.boardIdsList = [];
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.showLeaveLoader = false;
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.boardIdsList = [];
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
    }

    hideSuccesfullFunction(){
      setTimeout(() => {
        this.sendSuccessful = false;
        this.showLinkCopied = false;
      }, 3000);
    }

    hideSuccesfullFunctionErrorDelete(){
      setTimeout(() => {
        this.sendSuccessfulErrorMsg = false;
      }, 5000);
    }

    nextSearchImage(currentIllusPos: any) {
      this.showSearchNextIcon = true;
      this.showSearchPreviosIcon = true;
      this.selectedFormatIndex = 0;
      this.imageDownloadShowFormat = "PNG";
      this.imageDownloadFormat = 'png';
      this.showDownloadDialog = false;
      this.closeImageEditField();
      this.addedTagList = [];
      if(currentIllusPos == this.imagesList.length-2) {
        this.showSearchNextIcon = false;
      }
      if(currentIllusPos <= this.imagesList.length) {
        for(var i = 0 ; i < this.imagesList.length ; i++) {
          this.currentIllus = this.imagesList[currentIllusPos+1];
          this.selectedVersion = this.currentIllus.current_cover;
          this.imageHeading = this.currentIllus.title;
          this.favImageHeading = this.currentIllus.title;
          this.hideEditImageName = true;
          this.hideEditFavImageName = true;
        }
        this.currentIllus.is_fav = this.currentIllus.is_fav;
        this.suggestedTags = [];
        this.getSuggestedTags(this.currentIllus.board, this.currentIllus.id);
        this.commentsList = [];
        this.getAssetsComments(this.currentIllus.board, this.currentIllus.id);
        this.currentSearchIllusPosition = currentIllusPos+1;
      } else {
        //
      }
    }

    previousSearchImage(currentIllusPos: any) {
      this.showSearchNextIcon = true;
      this.showSearchPreviosIcon = true;
      this.selectedFormatIndex = 0;
      this.imageDownloadShowFormat = "PNG";
      this.imageDownloadFormat = 'png';
      this.showDownloadDialog = false;
      this.closeImageEditField();
      this.addedTagList = [];
      if(currentIllusPos == 0) {
        this.showSearchPreviosIcon = false;
      } else {
        for(var i = 0 ; i < this.imagesList.length ; i++) {
          this.currentIllus = this.imagesList[currentIllusPos-1];
          this.selectedVersion = this.currentIllus.current_cover;
          this.imageHeading = this.currentIllus.title;
          this.favImageHeading = this.currentIllus.title;
          this.hideEditImageName = true;
          this.hideEditFavImageName = true;
        }
        this.currentIllus.is_fav = this.currentIllus.is_fav;
        this.suggestedTags = [];
        this.getSuggestedTags(this.currentIllus.board, this.currentIllus.id);
        this.commentsList = [];
        this.getAssetsComments(this.currentIllus.board, this.currentIllus.id);
        this.currentSearchIllusPosition = currentIllusPos-1;
      }
    }

    nextImage(currentIllusPos: any) {
      this.selectedFormatIndex = 0;
      this.imageDownloadShowFormat = "PNG";
      this.imageDownloadFormat = 'png';
      this.showDownloadDialog = false;
      this.showEditImageName = false;
      this.showEditFavImageName = false;
      this.hideEditImageName = true;
      this.hideEditFavImageName = true;
      this.closeImageEditField();
      this.addedTagList = [];
      if(currentIllusPos == this.sortedImagesList.length-2) {
        this.showNextIcon = false;
      }
      if(currentIllusPos <= this.sortedImagesList.length-2) {
        for(var i = 0 ; i < this.sortedImagesList.length ; i++) {
          this.currentIllus = this.sortedImagesList[currentIllusPos+1];
          this.selectedVersion = this.currentIllus.current_cover;
          this.imageHeading = this.currentIllus.title;
          this.favImageHeading = this.currentIllus.title;
          this.hideEditImageName = true;
          this.hideEditFavImageName = true;
        }
        this.suggestedTags = [];
        this.getSuggestedTags(this.currentIllus.board, this.currentIllus.id);
        this.commentsList = [];
        this.getAssetsComments(this.currentIllus.board, this.currentIllus.id);
        this.currentIllusPosition = currentIllusPos+1;
      } else {
        //
      }
    }

    previousImage(currentIllusPos: any) {
      this.selectedFormatIndex = 0;
      this.imageDownloadShowFormat = "PNG";
      this.imageDownloadFormat = 'png';
      this.showDownloadDialog = false;
      this.showEditImageName = false;
      this.showEditFavImageName = false;
      this.hideEditImageName = true;
      this.hideEditFavImageName = true;
      this.closeImageEditField();
      this.addedTagList = [];
      if(currentIllusPos == 0) {
        this.showPreviosIcon = false;
      } else {
        for(var i = 0 ; i < this.sortedImagesList.length ; i++) {
          this.currentIllus = this.sortedImagesList[currentIllusPos-1];
          this.selectedVersion = this.currentIllus.current_cover;
          this.imageHeading = this.currentIllus.title;
          this.favImageHeading = this.currentIllus.title;
          this.hideEditImageName = true;
          this.hideEditFavImageName = true;
        }
        this.suggestedTags = [];
        this.getSuggestedTags(this.currentIllus.board, this.currentIllus.id);
        this.commentsList = [];
        this.getAssetsComments(this.currentIllus.board, this.currentIllus.id);
        this.currentIllusPosition = currentIllusPos-1;
      }
    }

    showGeneratedLink() {
      this.isShowShareLinkGenerated = true;
    }

    copyShareLink(inputElement){
      if(this.allowDownloadSelected) {
        this.allowDownloads = 1;
      } else {
        this.allowDownloads = 0;
      }

      if(this.showCommentSelected) {
        this.showComments = 1;
      } else {
        this.showComments = 0;
      }

      if(this.allowCommentingSelected) {
        this.allowComments = 1;
      } else {
        this.allowComments = 0;
      }

      if(this.fromAssets) {
        this.subscriptionService.shareAssetsSettingsData(this.sharedToken,
          this.allowDownloads, this.expiryLinkIn, this.showComments, this.allowComments).subscribe((data) => {

        },(error: any) => {
          if(error.status == 400){
            this.sendSuccessfulErrorMsg = true;
            this.sendSuccessfulErrorMessage = error.error.message;
            this.hideSuccesfullFunctionErrorDelete();
          } else {
            this.sendSuccessfulErrorMsg = true;
            this.sendSuccessfulErrorMessage = error.error.message;
            this.hideSuccesfullFunctionErrorDelete();
          }
        });
      } else {
        this.subscriptionService.shareBoardsSettingsData(this.sharedToken,
          this.allowDownloads, this.expiryLinkIn, this.showComments, this.allowComments).subscribe((data) => {

        },(error: any) => {
          if(error.status == 400){
            this.sendSuccessfulErrorMsg = true;
            this.sendSuccessfulErrorMessage = error.error.message;
            this.hideSuccesfullFunctionErrorDelete();
          } else {
            this.sendSuccessfulErrorMsg = true;
            this.sendSuccessfulErrorMessage = error.error.message;
            this.hideSuccesfullFunctionErrorDelete();
          }
        });
      }
      inputElement.select();
      document.execCommand('copy');
      this.showLinkCopied = true;
      inputElement.setSelectionRange(0, 0);
      this.hideSuccesfullFunction();
    }

    shareBoard(boardId: any) {
      this.fromAssets = false;
      this.shareImageLink = "";
      this.hitShareBoardApi(boardId);
    }

    hitShareBoardApi(boardId) {
      this.subscriptionService.hitBoardShare(this.workspaceId, boardId, "").subscribe((data) => {
        this.shareableLink = data.link;
        this.sharedToken = data.token;
        this.shareLinkStyle = "block";
        this.hideContent();
      },(error: any) => {
        this.hideContent();
        if(error.status == 400){
          this.alert.error(error.error.message)
        } else {
          this.alert.error(error.error.message)
        }
     });
    }

    hideContent() {
      this.imagesIdList = [];
      this.changeColor = [];
      this.imageSelected = false;
      this.downloadDelete = false;
      this.count = 0;
    }

    goToMarketplace() {
      window.open("https://crafttor.com/marketplace", "_blank");
    }

    goToFeedback() {
      window.open("https://workspace.crafttor.com/feedbacks", "_blank");
    }

    getInitial(fullEmail: string) {
      const words = fullEmail.split(' ');
      let initials = '';

      if (words.length > 2) {
        initials = words.slice(0, 2).map(word => word.charAt(0)).join('').toUpperCase();
      } else {
        initials = words.map(word => word.charAt(0)).join('').toUpperCase();
      }

      return initials;
     }

    deleteSingleSearchDialogImage(imgId: any){
      //this.damService.deleteImages
      this.damService.archiveSingleImages(this.workspaceId, this.boardId, imgId).subscribe((data: any) => {
        this.searchArrayImages(this.searchText, this.searchTerms);
      },(error) => {
        if(error.status == 403){
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = "You are not allowed to delete this asset.";
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = "Something went wrong.";
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
    }

    deleteSingleTimelineDialogImage(imgId: any){
      //this.damService.deleteImages
      this.damService.archiveSingleImages(this.workspaceId, this.boardId, imgId).subscribe((data: any) => {
        this.getBoardsListing(this.workspaceId);
      },(error) => {
        if(error.status == 403){
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = "You are not allowed to delete this asset.";
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = "Something went wrong.";
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
    }

    showDownloadPopup() {
      if(this.showDownloadDialog == true) {
        this.showDownloadDialog = false;
      } else if(this.showDownloadDialog == false){
        this.showDownloadDialog = true;
      }
    }

    changeFormatColors(i){
        this.selectedFormatIndex = i;
    }

    getImage(currentImage: any, format: any) {
      this.imageDownloadShowFormat = format;
      if (format == 'PNG') {
        this.imageDownloadFormat = 'png';
      } else if (format == 'JPEG') {
        this.imageDownloadFormat = 'jpeg';
      } else if (format == 'TIFF') {
        this.imageDownloadFormat = 'tiff';
      } else if (format == 'WEBP') {
        this.imageDownloadFormat = 'webp';
      } else if (format == 'SVG') {
        this.imageDownloadFormat = 'svg';
      } else if (format == 'GIF') {
        this.imageDownloadFormat = 'GIF';
      } else if (format == 'AI') {
        this.imageDownloadFormat = 'ai';
      } else if (format == 'BMP') {
        this.imageDownloadFormat = 'bmp';
      }
    }

    downloadFormatImage(currentImageId: any, titleImage: string, boardId: any): void {
      this.showDownloadLoader = true;
      this.damService.downloadFormatImages(this.workspaceId, boardId, currentImageId, this.imageDownloadFormat).subscribe((data: any) => {
        let stringToSplit = titleImage;
        let imageName = stringToSplit.split(".");
        saveAs(data, imageName[0])
        this.showDownloadLoader = false;
        this.showDownloadDialog = false;
      },
        (error: any) => {
          this.showDownloadLoader = false;
          if (error.status === 403) {
            // this.openLimitModal(this.limitModal);
          }
          else {
            // this.alert.alert("Alert", "Limit reached! Please login to download")
          }
        }
      );
    }

    @ViewChild(PdfViewerComponent, {static: false})
    private pdfComponent: PdfViewerComponent;
    pageRendered() {
      this.pdfComponent.pdfViewer.currentScaleValue = 'page-fit';
    }

    deleteImageVersion(currentIllusPos: any, version: any, boardId: any, imageId: any) {
      this.damService.deleteImageVersion(this.workspaceId, boardId, imageId, version).subscribe((data: any) => {
        this.damService.getSortedImagesList(this.workspaceId).subscribe((data: any) => {
          this.sortedImagesList = data;
          this.mainSection = false;
          this.mobileViewSection = false;
          this.timelineSection = true;
          this.tableViewSection = false;
          this.tableViewData = false;
          this.folderViewSection = false;
          this.folderViewData = false;
          this.searchImageslistSection = false;
          for(var i = 0 ; i < this.sortedImagesList.length ; i++) {
            this.currentIllus = this.sortedImagesList[currentIllusPos];
          }
        });
      },
      (error) => {
        if(error.status == 403 || error.status == 401 || error.status == 400){
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
    }

    deleteSearchImageVersion(currentIllusPos: any, version: any, boardId: any, imageId: any) {
      this.damService.deleteImageVersion(this.workspaceId, boardId, imageId, version).subscribe((data: any) => {
        this.damService.searchImages(this.workspaceId, this.searchTextSet).subscribe((data: any) => {
          this.imagesList = data.image;
          this.searchData = this.searchText;
          this.mainSection = false;
          this.mobileViewSection = false;
          this.tableViewSection = false;
          this.tableViewData = false;
          this.timelineSection = false;
          this.folderViewSection = false;
          this.folderViewData = false;
          this.searchImageslistSection = true;
          this.selectedVersion = version;
          for(var i = 0 ; i < this.imagesList.length ; i++) {
            this.currentIllus = this.imagesList[currentIllusPos];
          }
        });
      },
      (error) => {
        if(error.status == 403 || error.status == 401 || error.status == 400){
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
    }

    makeCoverImageVersion(currentIllusPos: any, version: any, boardId: any, imageId: any) {
      this.damService.makeCoverImageVersion(this.workspaceId, boardId, imageId, version).subscribe((data: any) => {
        this.damService.getSortedImagesList(this.workspaceId).subscribe((data: any) => {
          this.sortedImagesList = data;
          this.mainSection = false;
          this.mobileViewSection = false;
          this.timelineSection = true;
          this.tableViewSection = false;
          this.tableViewData = false;
          this.folderViewSection = false;
          this.folderViewData = false;
          this.searchImageslistSection = false;
          for(var i = 0 ; i < this.sortedImagesList.length ; i++) {
            this.currentIllus = this.sortedImagesList[currentIllusPos];
          }
        });
      },
      (error) => {
        if(error.status == 403 || error.status == 401 || error.status == 400){
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
    }

    makeSearchCoverImageVersion(currentIllusPos: any, version: any, boardId: any, imageId: any) {
      this.damService.makeCoverImageVersion(this.workspaceId, boardId, imageId, version).subscribe((data: any) => {
        this.damService.searchImages(this.workspaceId, this.searchTextSet).subscribe((data: any) => {
          this.imagesList = data.image;
          this.searchData = this.searchText;
          this.mainSection = false;
          this.mobileViewSection = false;
          this.timelineSection = false;
          this.tableViewSection = false;
          this.tableViewData = false;
          this.folderViewSection = false;
          this.folderViewData = false;
          this.searchImageslistSection = true;
          this.selectedVersion = version;
          for(var i = 0 ; i < this.imagesList.length ; i++) {
            this.currentIllus = this.imagesList[currentIllusPos];
          }
        });
      },
      (error) => {
        if(error.status == 403 || error.status == 401 || error.status == 400){
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
    }

    selectFilesVersion(fromDialog: any, event, currentIllusPos: any, boardHeading: string, boardId: any, imageId: any): void {
      this.progressInfos = [];
      this.replaceAsset = true;

      const files = event.target.files;
      let isImage = true;
      for (let i = 0; i < files.length; i++) {
        if (files.item(i).type.match('pdf.*') || files.item(i).type.match('image.*') || files.item(i).type.match('video.*')) {
          continue;
        } else {
          isImage = false;
          alert('Invalid Format!');
          break;
        }
      }

      if (isImage) {
        this.selectedFiles = event.target.files;
        this.uploadFilesVersion(fromDialog, event, currentIllusPos, boardHeading, boardId, imageId);
      } else {
        this.selectedFiles = undefined;
        event.srcElement.percentage = null;
      }
    }

    uploadFilesVersion(fromDialog: any, event, currentIllusPos, boardHeading: string, boardId: any, imageId: any): void {
      this.message = '';
      for (let i = 0; i < this.selectedFiles.length; i++) {
        // this.getImageResolution(this.selectedFiles[i], i, );
        this.addVersionImage(fromDialog, i, currentIllusPos, this.selectedFiles[i], boardHeading, boardId, imageId);
      }
    }

    addVersionImage(fromDialog: any, idx, currentIllusPos: any, file, boardHeading: string, boardId: any, imageId: any): void {
      this.progressInfos[idx] = { value: 0, fileName: file.name };
      this.uploadService.uploadImageVersion(file, file.name, boardHeading, boardId, this.workspaceId, imageId).subscribe(
        event => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progressInfos[idx].percentage = Math.round(100 * event.loaded / event.total);
            this.progressPecentage = this.progressInfos[idx].percentage;
          } else if (event instanceof HttpResponse) {
            if (fromDialog == 'timeLineDialog') {
              this.damService.getSortedImagesList(this.workspaceId).subscribe((data: any) => {
                this.sortedImagesList = data;
                this.mainSection = false;
                this.mobileViewSection = false;
                this.timelineSection = true;
                this.tableViewSection = false;
                this.tableViewData = false;
                this.folderViewSection = false;
                this.folderViewData = false;
                this.searchImageslistSection = false;
                for(var i = 0 ; i < this.sortedImagesList.length ; i++) {
                  this.currentIllus = this.sortedImagesList[currentIllusPos];
                }
              });
            } else if(fromDialog == 'searchDialog') {
              this.damService.searchImages(this.workspaceId, this.searchTextSet).subscribe((data: any) => {
                this.imagesList = data.image;
                this.searchData = this.searchText;
                this.mainSection = false;
                this.mobileViewSection = false;
                this.timelineSection = false;
                this.tableViewSection = false;
                this.tableViewData = false;
                this.folderViewSection = false;
                this.folderViewData = false;
                this.searchImageslistSection = true;
                for(var i = 0 ; i < this.imagesList.length ; i++) {
                  this.currentIllus = this.imagesList[currentIllusPos];
                }
              });
            }
          }
        },
        (error: any) => {
          if(error.status == 400){
            this.isShowLoadingStatusDone = false;
            this.isShowLoadingStatus = false;
            this.uploadedFileName = error.error.title.title;
            this.openUploadOptionsStyleBoard();
          } else {
            this.isShowLoadingStatusDone = false;
            this.isShowLoadingStatus = false;
            this.alert.error("Something went wrong");
          }
       }
      );
    }

    setMainImage(imgLink: any, version: any) {
      this.selectedVersion = version;
      this.currentIllus.image = imgLink;
    }

    downloadVersionImage(currentImageId: any, titleImage: string, boardId: any, version: any): void {
      this.damService.downloadVersionImages(this.workspaceId, boardId, currentImageId, version).subscribe((data: any) => {
        saveAs(data, titleImage)
      },
        (error: any) => {
          if (error.status === 403) {
            // this.openLimitModal(this.limitModal);
          }
          else {
            // this.alert.alert("Alert", "Limit reached! Please login to download")
          }
        }
      );
    }

    openVersionImages() {
      this.showSmallImg = true;
    }

    closeVersionImages() {
      this.showSmallImg = false;
    }

    openUploadOptionsStyleBoard() {
      this.uploadOptionsStyle = "block";
    }

    closeUploadOptionsStyleBoard() {
      this.uploadOptionsStyle = "none";
    }

    showUploadReplaceDialog() {
      this.uploadVersionStyle = "block";
    }

    closeUploadReplaceDialog() {
      this.uploadVersionStyle = "none";
    }

    openFigma() {
      this.googleAnalyticsService.event('figma_dam_screen', 'figma_icon', this.currentUser.firstName +" "+this.currentUser.lastName);
      window.open("https://www.figma.com/community/plugin/902086023682633830/Crafttor", "_blank");
    }

    openSketch() {
      this.googleAnalyticsService.event('sketch_dam_screen', 'sketch_icon', this.currentUser.firstName +" "+this.currentUser.lastName);
      window.open("https://crafttor.com/sketch", "_blank");
    }

    openIllustrator() {
      this.googleAnalyticsService.event('ai_dam_screen', 'ai_icon', this.currentUser.firstName +" "+this.currentUser.lastName);
      window.open("https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator", "_blank");
    }

    onSubmitReplyComment(imgId: any, commentId: any, replyMsg: any, boardId: any) {
      if(this.userSelectedForReplyTag) {
        this.taggingComments(boardId, imgId, commentId, replyMsg, this.selectedUserIdForTag)
      } else {
        this.postAssetsReplyComments(imgId, commentId, replyMsg);
      }
    }

    onSubmitCommentSection(imgId: any, mainMsg: any, boardId: any) {
      if(this.userSelectedForTag) {
        this.taggingComments(boardId, imgId, "", mainMsg, this.selectedUserIdForTag)
      } else {
        this.postAssetsComments(imgId, mainMsg);
      }
    }

    postAssetsComments(imageId: any, mainMsg: any) {
      this.openEditBox = false;
      if (this.mainMsgForm.valid) {
        this.showChatLoader = true;
        this.damService.postAssetComment(this.workspaceId, this.boardId, imageId,
          this.commentId, mainMsg).subscribe((data) => {
            this.selectedUserIdForTag = "";
            this.showChatLoader = false;
            this.commentMsg = "";
            this.replyMsg = "";
            this.textArea = "";
            this.mainMsgForm.reset();
            this.getAssetsComments(this.boardId, imageId);
        },
        (error: any) => {
          if(error.status == 400 || error.status == 403){
          } else {
            // this.getUnResolveComments(this.boardId, imageId);
          }
       });
      }
    }

    postAssetsReplyComments(imageId: any, commentId: any, replyMsg: any) {
      this.openEditBox = false;
      this.submitted = true;
      if (this.replyForm.valid) {
        this.damService.postAssetComment(this.workspaceId, this.boardId, imageId,
          commentId, replyMsg).subscribe((data) => {
            this.selectedUserIdForTag = "";
            this.commentMsg = "";
            this.replyMsg = "";
            this.replyArea = "";
            this.replyForm.reset();
            this.getAssetsComments(this.boardId, imageId);
        },
        (error: any) => {
          if(error.status == 400 || error.status == 403){
            // this.getUnResolveComments(this.boardId, imageId);
          } else {
            // this.getUnResolveComments(this.boardId, imageId);
          }
       });
      }
    }

    getAssetsComments(boardId: any, assetId: any) {
      this.openEditBox = false;
      this.damService.getAssetComment(this.workspaceId, boardId, assetId).subscribe((data) => {
          this.commentsList = data['results'];
          this.noComments = "No comments!!";
          this.damService.getAllUsersList(this.workspaceId).subscribe((data: any) => {
            this.usersList = data;
          });
      });
    }

    deleteComments(boardId: any, assetId: any, commentId: any) {
      this.openEditBox = false;
      this.damService.deleteAssetComment(this.workspaceId, boardId, assetId, commentId).subscribe((data) => {
        this.getAssetsComments(boardId, assetId);
      });
    }

    public editComments(boardId: any, assetId: any, commentId: any) {
      this.submitted = true;
      if (this.commentForm.valid) {
        this.damService.editAssetComment(this.workspaceId, boardId, assetId, commentId,
          this.commentForm.value.comment).subscribe((data) => {
          this.openEditBox = false;
          this.editComment = "";
          this.commentForm.value.comment = "";
          this.getAssetsComments(boardId, assetId);
        });
      }
    }

    public getUnResolveComments(boardId: any, assetId: any) {
      this.openEditBox = false;
      this.damService.unResolveComment(this.workspaceId, boardId, assetId).subscribe((data) => {
        this.commentsList = data['results'];
        this.noComments = "No open comments!!";
      });
    }

    public resolvedListComments(boardId: any, assetId: any) {
      this.openEditBox = false;
      this.damService.resolvedListComment(this.workspaceId, boardId, assetId).subscribe((data) => {
        this.commentsList = data['results'];
        this.noComments = "No resolved comments!!";
      });
    }

    public postResolvedComments(boardId: any, assetId: any, commentId: any) {
      this.openEditBox = false;
      this.damService.resolvedComment(this.workspaceId, boardId, assetId, commentId).subscribe((data) => {
        this.getUnResolveComments(boardId, assetId);
      });
    }

    public taggingComments(boardId: any, assetId: any, commentId: any, commentMsg: any, userId: any) {
      this.openEditBox = false;
      if(commentMsg != "" || commentMsg != null) {
        this.showChatLoader = true;
        this.damService.taggingComment(this.workspaceId, boardId, assetId,
          commentId, commentMsg, userId).subscribe((data) => {
            this.selectedUserIdForTag = "";
            this.showChatLoader = false;
            this.commentMsg = "";
            this.replyMsg = "";
            this.textArea = "";
            this.replyArea = "";
            this.replyForm.reset();
            this.mainMsgForm.reset();
            this.getAssetsComments(this.boardId, assetId);
        });
      }
    }

    public isEmojiPickerVisible: boolean;
    @ViewChild("mainMsgData") commentField;

    public addEmoji(event) {
      this.textArea = `${this.textArea}${event.emoji.native}`;
      this.isEmojiPickerVisible = false;
      this.commentField.nativeElement.focus();
    }

    public isEmojiPickerVisibleReply: boolean;
    @ViewChild("replyData") replyField;

    public addReplyEmoji(event) {
      this.replyArea = `${this.replyArea}${event.emoji.native}`;
      this.isEmojiPickerVisible = false;
    }

    openEditComment () {
      this.openEditBox = true;
    }

    openReplyBoxes(index) {
      this.showChatLoader = false;
      this.replyMsg = "";
      this.replyArea = "";
      this.replyForm.reset();
      this.index = index;
    }

    hitUsersListApi(event) {
      if(event.target.value === "@") {
        this.showUsersListDialog = true;
      } else if(event.target.value === "") {
        this.selectedUserIdForTag = "";
        this.showUsersListDialog = false;
        this.userSelectedForTag = false;
      } else {
        this.showUsersListDialog = false;
      }
    }

    selectedTagUser(userId: any, userFirstName: string) {
      this.showUsersListDialog = false;
      this.userSelectedForTag = true;
      this.selectedUserIdForTag = userId;
      this.textArea = userFirstName;
      this.selectedUserNameForTag = userFirstName;
    }

    hitUsersListReplyApi(event) {
      if(event.target.value === "@") {
        this.showUsersListReplyDialog = true;
      } else if(event.target.value === "") {
        this.selectedUserIdForTag = "";
        this.showUsersListReplyDialog = false;
        this.userSelectedForReplyTag = false;
      } else {
        this.showUsersListReplyDialog = false;
      }
    }

    selectedReplyTagUser(userId: any, userFirstName: string) {
      this.showUsersListReplyDialog = false;
      this.userSelectedForReplyTag = true;
      this.selectedUserIdForTag = userId;
      this.replyArea = userFirstName;
    }

    resetFields() {
      this.commentMsg = "";
      this.replyMsg = "";
      this.textArea = "";
      this.replyArea = "";
      this.replyForm.reset();
      this.mainMsgForm.reset();
    }

    createSubBoard(mainBoardName: string, boardId: any) {
      this.showCreateBoardErrorSub = false;
      this.createSubBoardForm.reset();
      this.createSubBoardMainBoardName = mainBoardName;
      this.createSubBoardId = boardId;
      this.createSubBoardStyle = "block";
    }

    closeSubBoardPopup() {
      this.createSubBoardLoader = false;
      this.showCreateBoardErrorSub = false;
      this.createSubBoardForm.reset();
      this.createSubBoardStyle = "none";
    }

   onCreateSubBoard(subBoardNames: string, ) {
     this.showCreateBoardErrorSub = false;
     if(this.createSubBoardForm.valid) {
       this.createSubBoardLoader = true;
       this.damService.createNewSubBoard(this.workspaceId, this.createSubBoardId, subBoardNames).subscribe((data: any) => {
         this.closeSubBoardPopup();
         // this.boardHeading = data.title;
         // this.boardId = data.id;
         // this.currentBoard = data.id;
         // this.displayStyle = "none";
         // this.boardlistClickNew(this.boardHeading, this.boardId);
       },(error: any) => {
         if(error.status == 400){
           this.createSubBoardLoader = false;
           this.showCreateBoardErrorSub = true;
           this.createSubBoardErrorMsg = error.error.message;
         } else {
           this.showCreateBoardErrorSub = true;
           this.createSubBoardErrorMsg = error.error.message;
         }
      });
     }
   }

   pinBoard(boardId: any) {
     this.damService.pinBoards(this.workspaceId, boardId).subscribe((data: any) => {
         this.reStartListing();
     },
     (error) => {
       if(error.status == 400){
         this.sendSuccessfulErrorMsg = true;
         this.sendSuccessfulErrorMessage = error.error.message;
         this.hideSuccesfullFunctionErrorDelete();
       } else {
         this.sendSuccessfulErrorMsg = true;
         this.sendSuccessfulErrorMessage = error.error.message;
         this.hideSuccesfullFunctionErrorDelete();
       }
     });
   }

   unPinBoard(boardId: any) {
     this.damService.unPinBoards(this.workspaceId, boardId).subscribe((data: any) => {
         this.reStartListing();
     },
     (error) => {
       if(error.status == 400){
         this.sendSuccessfulErrorMsg = true;
         this.sendSuccessfulErrorMessage = error.error.message;
         this.hideSuccesfullFunctionErrorDelete();
       } else {
         this.sendSuccessfulErrorMsg = true;
         this.sendSuccessfulErrorMessage = error.error.message;
         this.hideSuccesfullFunctionErrorDelete();
       }
     });
   }

   onSubmit() {
     if(this.searchText.length > 0) {
       this.searchTerms.push(this.searchText);
       this.searchArrayImages(this.searchText, this.searchTerms);
     }
   }

   searchArrayImages(searchText: any, searchTermArray: any){
     this.downloadDelete = false;
     this.imagesIdList = [];
     this.changeColor = [];
     this.imageSelected = false;
     this.searchTextSet = searchText;
     this.damService.searchImagesArray(this.workspaceId, searchTermArray).subscribe((data: any) => {
       this.searchText = "";
       this.imagesList = data.image;
       this.searchData = '' + this.searchTextSet;
       this.mainSection = false;
       this.mobileViewSection = false;
       this.timelineSection = false;
       this.tableViewSection = false;
       this.tableViewData = false;
       this.folderViewSection = false;
       this.folderViewData = false;
       this.searchImageslistSection = true;
     });
   }

   removeSearchTerm(index: number, searchTerm: any) {
     this.searchTerms.splice(index, 1);
     if(this.searchTerms.length > 0) {
       this.searchArrayImages(searchTerm, this.searchTerms);
     } else {
       this.mainSection = false;
       this.mobileViewSection = false;
       this.timelineSection = false;
       this.tableViewSection = false;
       this.tableViewData = false;
       this.folderViewSection = false;
       this.folderViewData = false;
       this.searchImageslistSection = true;
       this.imagesList = [];
     }
   }

   archiveSingleTimeLineImage(imgId: any, pos: any, boardId: any, imgTitle: any) {
     this.showTopRightLoader = true;
     this.currentSearchIllusPosition = pos;
     // this.imageDeleteProcessStyle = "block";
     this.damService.archiveSingleImages(this.workspaceId, boardId, imgId).subscribe((data: any) => {
       this.showTopRightLoader = false;
       this.sendSuccessful = true;
       this.successfullMessage = imgTitle + " moved to trash";
       this.hideSuccesfullFunction();
       this.timelineClick();
     });
   }

   archiveSingleSearchImage(imgId: any, pos: any, boardId: any,
     fromWhichSection: any, imgTitle: any) {
     this.showTopRightLoader = true;
     this.currentSearchIllusPosition = pos;
     // this.imageDeleteProcessStyle = "block";
     this.damService.archiveSingleImages(this.workspaceId, boardId, imgId).subscribe((data: any) => {
       this.showTopRightLoader = false;
       this.sendSuccessful = true;
       this.successfullMessage = imgTitle + " moved to trash";
       this.hideSuccesfullFunction();
       if(fromWhichSection == 'table') {
         this.getSortedImagesList();
       } else if(fromWhichSection == 'search') {
         this.searchArrayImages(this.searchText, this.searchTerms);
       }
     });
   }

   openMoveImagesStyleBoard(imageId: any, moveFromScreen: any, pos: any, boardId: any){
     this.moveFromSearch = moveFromScreen;
     this.imagesIds.push(imageId);
     this.currentSearchIllusPosition = pos;
     this.damService.getMoveBoardsList(this.workspaceId, boardId).subscribe((data: any) => {
       this.moveBoards = data;
     },
       (error: any) => {
         if (error.status == 403) {
           this.alert.error("Something went wrong");
         }
         else {
           this.alert.error("Something went wrong");
         }
       }
     );
     this.moveImagesStyle = "block";
   }

   downloadSingleImage(imgId: any, imgTitle: string, boardId: any){
     this.damService.downloadImages(this.workspaceId, boardId, imgId).subscribe((data: any) => {
         saveAs(data, imgTitle)
         this.imagesIdList = [];
         this.imagesIds = [];
         this.changeColor = [];
         this.imageSelected = false;
         this.downloadDelete = false;
         this.count = 0;
      },(error) => {
        const errors = error.error || error.statusText;
        Object.keys(errors).map((key) => {
          errors[key].map((message) => {
            this.alert.error(message);
            this.imagesIdList = [];
            this.imagesIds = [];
            this.changeColor = [];
            this.imageSelected = false;
            this.downloadDelete = false;
            this.count = 0;
          })
        })
      });
   }

   verifyAssets(assetsIds: any){
     this.sendSuccessful = false;
     this.showTopRightLoader = true;
     this.asssetsIdsList.push(assetsIds);
     this.inboxService.verifyAssets(this.workspaceId, this.asssetsIdsList).subscribe((data: any) => {
       this.showTopRightLoader = false;
       this.sendSuccessful = true;
       this.successfullMessage = data.message;
       this.asssetsIdsList = [];
       this.hideSuccesfullFunction();
     },(error: any) => {
       if(error.status == 400){
         this.showTopRightLoader = false;
         this.sendSuccessfulErrorMsg = true;
         this.sendSuccessfulErrorMessage = error.error.message;
         this.asssetsIdsList = [];
         this.hideSuccesfullFunctionErrorDelete();
       } else {
         this.showTopRightLoader = false;
         this.sendSuccessfulErrorMsg = true;
         this.sendSuccessfulErrorMessage = error.error.message;
         this.asssetsIdsList = [];
         this.hideSuccesfullFunctionErrorDelete();
       }
    });
   }

   closeMoveImagesStyleBoard() {
    this.moveImagesStyle = "none";
    this.boardSearchKeyword = '';
    this.showSearchBoardOlderList = true;
    this.showSearchBoardList = false;
   }

   moveImagesToOtherBoard(newBoardId: any, boardTitle: string) {
     this.sendSuccessful = false;
     this.downloadDelete = false;
     this.closeMoveImagesStyleBoard();
     this.showTopRightLoader = true;
     this.damService.moveImagesToOtherBoard(this.workspaceId, this.boardId,
       this.imagesIds, newBoardId).subscribe((data: any) => {
         // this.closeDeleteStyleBoard();
         this.showTopRightLoader = false;
         this.sendSuccessful = true;
         this.successfullMessage = data.message;
         this.hideSuccesfullFunction();
         if(this.moveFromSearch == 'timeline') {
           this.timelineSection = true;
           this.searchImageslistSection = false;
           this.tableViewSection = false;
           this.tableViewData = false;
           this.folderViewSection = false;
           this.folderViewData = false;
           this.mainSection = false;
           this.mobileViewSection = false;
         } else if(this.moveFromSearch == 'search') {
           this.timelineSection = false;
           this.searchImageslistSection = true;
           this.tableViewSection = false;
           this.tableViewData = false;
           this.mainSection = false;
           this.folderViewSection = false;
           this.folderViewData = false;
           this.mobileViewSection = false;
           this.searchArrayImages(this.searchText, this.searchTerms);
         }else if(this.moveFromSearch == 'table') {
           this.getSortedImagesList();
         }
     },(error) => {
       this.closeMoveImagesStyleBoard();
       this.showTopRightLoader = false;
       const errors = error.error || error.statusText;
       Object.keys(errors).map((key) => {
         errors[key].map((message) => {
           this.imagesIdList = [];
           this.imagesIds = [];
           this.changeColor = [];
           this.imageSelected = false;
           this.downloadDelete = false;
           this.openBoardList = false;
           this.showSearchBoardOlderList = true;
           this.showSearchBoardList = false;
           this.boardSearchKeyword = '';
           this.count = 0;
           this.alert.error(message);
         })
       })
     });
   }

   onSearchBoards() {
     this.searchBoards(this.boardSearchKeyword);
   }

   searchBoards(searchText: string = ""){
     this.downloadDelete = false;
     this.changeColor = [];
     this.imageSelected = false;
     this.damService.searchBoards(this.workspaceId, searchText).subscribe((data: any) => {
       this.searchedBoards = data;
       this.showSearchBoardOlderList = false;
       this.showSearchBoardList = true;
       this.boardSearchKeyword = '';
     },(error) => {
       this.closeMoveImagesStyleBoard();
       const errors = error.error || error.statusText;
       Object.keys(errors).map((key) => {
         errors[key].map((message) => {
           this.boardSearchKeyword = '';
           this.showSearchBoardOlderList = true;
           this.showSearchBoardList = false;
           this.alert.error(message);
         })
       })
     });
   }

   allowDownload() {
     if(this.allowDownloadSelected) {
       this.allowDownloadSelected = false;
     } else {
       this.allowDownloadSelected = true;
     }
   }

   allowShowComments() {

   }

   allowCommenting() {

   }

   selectExpireLink (event: any) {
     this.expiryLinkIn = event.target.value;
   }

   openAssetRenameDialog(assetId: any, currentName: any, boardId: any,
     imageLink: any, fromWhichSection: any) {
       this.fromWhichSection = fromWhichSection;
       this.renameImageLink = imageLink;
       this.renameErrorMsg = "";
       this.assetCurrentId = assetId;
       this.assetCurrentName = currentName;
       this.renameBoardId = boardId;
       this.assetNewName = currentName;
       this.assetRenameStyle = "block";
   }

   closeAssetRenameDialog() {
     this.renameErrorMsg = "";
     this.assetRenameStyle = "none";
   }

   assetRename() {
     this.renameErrorMsg = "";
     this.showRenameLoader = true;
     this.damService.changeImageNameApi(this.workspaceId, this.renameBoardId, this.assetCurrentId, this.assetNewName).subscribe((data: any) => {
       this.renameImageLink = "";
       this.assetRenameStyle = "none";
       this.showRenameLoader = false;
       this.sendSuccessful = true;
       this.successfullMessage = "Renamed " + this.assetCurrentName + " to " +this.assetNewName;
       this.hideSuccesfullFunction();
       if(this.fromWhichSection == 'timeline') {
         this.timelineClick();
       } else if(this.fromWhichSection == 'search') {
         this.searchArrayImages(this.searchText, this.searchTerms);
       } else if(this.fromWhichSection == 'table') {
         this.getSortedImagesList();
       }
     },
     (error: any) => {
       if(error.status == 403 || error.status == 400){
         this.showRenameLoader = false;
         this.renameErrorMsg = error.error.message;
       } else {
         this.showRenameLoader = false;
         this.renameErrorMsg = error.error.message;
       }
    });
   }

   openEditTagsDialog(assetId: any, currentName: any, imageLink: any,
     boardId: any, fromWhichSection: any, imgFormat: any) {
       this.fromWhichSection = fromWhichSection;
       this.editTagsImageLink = imageLink;
       this.editTagsImageFormats = imgFormat;
       this.editTagsError = "";
       this.assetCurrentId = assetId;
       this.assetCurrentName = currentName;
       this.assetBoardId = boardId;
       this.assetEditTagsStyle = "block";
   }

   closeEditTagsDialog() {
     this.assetEditTagsStyle = "none";
   }

   onSubmitMultipleTags() {
     if(this.tagsForm.valid) {
       this.editTagsList.push(this.tagsForm.value['edittags']);
       this.tagsForm.reset();
     }
   }

   removeAddedTags(index: number) {
     this.editTagsList.splice(index, 1);
   }

   editMultipleTags() {
     this.editTagsError = "";
     if (this.editTagsList.length === 0) {
       this.editTagsError = "Add a tag and press Enter.";
     } else {
       this.showEditTagsLoader = true;
       this.damService.addMultipleImageTags(this.workspaceId, this.assetBoardId, this.assetCurrentId,
         this.editTagsList.join(', ')).subscribe((data: any) => {
           this.editTagsList = [];
           this.showEditTagsLoader = false;
           this.assetEditTagsStyle = "none";
           this.editTagsImageLink = "";
           this.editTagsImageFormats = "";
           this.sendSuccessful = true;
           this.successfullMessage = "Tags added successfully!!"
           this.hideSuccesfullFunction();
           if(this.fromWhichSection == 'timeline') {
             this.timelineClick();
           } else if(this.fromWhichSection == 'search') {
             this.searchArrayImages(this.searchText, this.searchTerms);
           } else if(this.fromWhichSection == 'table') {
             this.getSortedImagesList();
           }
       },
       (error: any) => {
         if(error.status == 403 || error.status == 400){
           this.showEditTagsLoader = false;
           this.editTagsError = error.error.message;
         } else {
           this.showEditTagsLoader = false;
           this.editTagsError = error.error.message;
         }
       });
     }
   }

   restoreAssets(boardId: any, imgId: any) {
     this.damService.restoreAssets(this.workspaceId, boardId, imgId).subscribe((data: any) => {
       this.searchArrayImages(this.searchText, this.searchTerms);
       this.sendSuccessful = true;
       this.successfullMessage = data.message;
       this.hideSuccesfullFunction();
     });
   }

   openEditBoardNames(boardId: any, boardTitle: any) {
     this.renameBoardMsg = "";
     this.boardCurrentName = boardTitle;
     this.editNameBoardId = boardId;
     this.boardNewName = boardTitle;
     this.boardRenameStyle = "block";
   }

   closeEditBoardNames() {
     this.renameBoardMsg = "";
     this.boardRenameStyle = "none";
   }

   editBoardNamesApi(){
     this.renameBoardMsg = "";
     this.showRenameLoader = true;
     this.damService.editBoardName(this.workspaceId, this.editNameBoardId, this.boardNewName).subscribe((data: any) => {
       this.boardHeading = data.title;
       this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
         this.boardRenameStyle = "none";
         this.showRenameLoader = false;
         this.boards = data;
         this.sendSuccessful = true;
         this.successfullMessage = "Renamed " + this.boardCurrentName + " to " +this.boardNewName;
         this.hideSuccesfullFunction();
       });
     },(error: any) => {
       if(error.status == 400){
         this.showRenameLoader = false;
         this.renameBoardMsg = error.error.message;
       } else {
         this.showRenameLoader = false;
         this.renameBoardMsg = error.error.message;
       }
    });
   }

   goToLibrary() {
     this.googleAnalyticsService.event('library_click_dam_screen_click', 'library_click', this.currentUser.firstName +" "+this.currentUser.lastName);
     this.router.navigate(['/library']);
   }

   createWorkspace(workspaceName: any){
     if (this.currentUser) {
       if(this.creatwWorkspace.valid) {
         this.showCreateWorkspaceLoader = true;
         this.isShowCreateWorkspaceError = false
         this.organisationService.createNewWorkspace(workspaceName).subscribe((data: any) => {
           this.showCreateWorkspaceLoader = false;
           this.showLeaveLoader = false;
           this.creatwWorkspace.reset();
           localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: data.id,
             workspaceName: data.title, userRole: data.role }));
           this.router.navigate(['/dam']);
           this.getWorkspaceDetails();
           this.closeNewWorkspaceDialog();
         },
         (error) => {
           if(error.status == 403){
             this.showLeaveLoader = false;
             this.showCreateWorkspaceLoader = false
             this.isShowCreateWorkspaceError = true
             this.createWorkspaceErrorMessage = error.error.Message;
           } else {
             this.showLeaveLoader = false;
             this.showCreateWorkspaceLoader = false;
             this.isShowCreateWorkspaceError = true
             this.createWorkspaceErrorMessage = error.error.Message;
           }
        });
       }
     }else{
       this.isShowCreateLoginWorkspaceError = true
       this.createWorkspaceLoginErrorMessage = "Login to Continue";
     }
   }

   openNewWorkspaceDialog() {
     this.createWorkspaceStyle = "block";
   }

   closeNewWorkspaceDialog() {
     this.createWorkspaceStyle = "none";
   }

   showOfferDialogToUsers() {
     this.organisationService.showOfferDialogApi().subscribe((data: any) => {
       this.dialogId = data[0].id;
       this.offerButtonTxt = data[0].button_text;
       this.offerTitleTxt = data[0].title;
       this.offerDescriptionTxt = data[0].description;
       this.offerDetailsDescriptionTxt = data[0].main_description;
       if(data[0].show_dialog_offer) {
         this.openOffersDialog();
       }
     },
     (error) => {
       if(error.status == 403){
         this.showLeaveLoader = false;
         this.isShowCreateWorkspaceError = true
         this.createWorkspaceErrorMessage = error.error.Message;
       } else {
         this.showLeaveLoader = false;
         this.isShowCreateWorkspaceError = true
         this.createWorkspaceErrorMessage = error.error.Message;
       }
     });
   }

   openOffersDialog() {
     this.offersStyle = "block";
   }

   closeOffersDialog() {
     this.offersStyle = "none";
   }

   seenOfferDialog() {
     this.organisationService.userSeenOfferDialogApi(this.dialogId, 'crossed').subscribe((data: any) => {
       this.closeOffersDialog();
     },
     (error) => {
       if(error.status == 403){
         this.showLeaveLoader = false;
         this.isShowCreateWorkspaceError = true
         this.createWorkspaceErrorMessage = error.error.Message;
       } else {
         this.showLeaveLoader = false;
         this.isShowCreateWorkspaceError = true
         this.createWorkspaceErrorMessage = error.error.Message;
       }
     });
   }

   openDataRequiredDialog() {
     this.dataRequiredStyle = "block";
   }

   closeDataRequiredDialog() {
     this.dataRequiredStyle = "none";
   }

   redirectToOfferCheckout() {
     this.organisationService.userSeenOfferDialogApi(this.dialogId, 'upgrade').subscribe((data: any) => {
       this.closeOffersDialog();
       localStorage.setItem('offerDialogId', JSON.stringify({ dialogId: this.dialogId }));
       this.openOfferCheckoutPage();
     },
     (error) => {
       if(error.status == 403){
         this.showLeaveLoader = false;
         this.isShowCreateWorkspaceError = true
         this.createWorkspaceErrorMessage = error.error.Message;
       } else {
         this.showLeaveLoader = false;
         this.isShowCreateWorkspaceError = true
         this.createWorkspaceErrorMessage = error.error.Message;
       }
     });
   }

   openOfferCheckoutPage() {
     this.router.navigate(['/offer-checkout-ajgdhjaduabsjxcssjheuw']);
   }

   showOfferPlans() {

   }

   submitDataRequired() {

   }

   openDataRequiredModal() {
     this.closeOffersDialog();
     this.openDataRequiredDialog();
   }

   selectedIndexData: number = 0;
   selectDataRequired (event: string, index: number) {
     this.dataRequired = event;
     this.selectedIndexData = index;
     if(this.dataRequired == '100GB') {
       this.totalDataAmount = "$100";
     } else if(this.dataRequired == '200GB') {
       this.totalDataAmount = "$180";
     } else if(this.dataRequired == '300GB') {
       this.totalDataAmount = "$260";
     } else if(this.dataRequired == '400GB') {
       this.totalDataAmount = "$340";
     } else if(this.dataRequired == '500GB') {
       this.totalDataAmount = "$420";
     } else if(this.dataRequired == '1TB') {
       this.totalDataAmount = "$800";
     } else if(this.dataRequired == '4TB') {
       this.totalDataAmount = "$1400";
     }
   }

   getSuggestedTags(boardId: any, imgId: any){
     this.damService.listGetSuggestedTags(this.workspaceId, boardId, imgId).subscribe((data: any) => {
       this.suggestedTags = data.labels;
     },
     (error) => {
       if(error.status == 400){

       } else {

       }
     });
   }

   welcomeKitClick() {
     localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
       workspaceName: this.workspaceName, userRole: this.userRole, welcomeId: "1" }));
     this.router.navigate(['/dam/welcome-kit']);
   }

   getWelcomeBoardsList(workspaceId: any) {
     this.damService.getWelcomeBoardsList(workspaceId).subscribe((data: any) => {
       this.welcomeBoards = data;
     });
   }

   editImageNameBoardId: any;

   editImageName(boardId: any){
     this.renameErrorMsg = "";
     this.imageNameEdit = this.imageHeading;
     this.editImageNameBoardId = boardId;
     this.showEditImageName = true;
     this.hideEditImageName = false;
     this.showEditFavImageName = false;
     this.hideEditFavImageName = false;
   }

   closeImageEditField(){
     this.renameErrorMsg = "";
     this.favImageNameEdit = "";
     this.imageNameEdit = "";
     this.editImageNameBoardId = '';
     this.editImageNameBoardId = '';
     this.showEditImageName = false;
     this.showAssetsRenameLoader = false;
     this.hideEditImageName = true;
     this.showEditFavImageName = false;
     this.hideEditFavImageName = true;
   }

   editNameDialogCloseScreen: String;

   editImageNameApi(imgId: any, imgFrom: any){
     this.editNameDialogCloseScreen = imgFrom;
     this.showAssetsRenameLoader = true;
     this.damService.changeImageNameApi(this.workspaceId, this.editImageNameBoardId, imgId, this.imageNameEdit).subscribe((data: any) => {
       this.showEditImageName = false;
       this.hideEditImageName = true;
       this.imageHeading = data.title;
       this.showEditFavImageName = false;
       this.hideEditFavImageName = true;
       this.renameErrorMsg = "";
       if(imgFrom == 'regularDialog') {
         this.damService.getSortedImagesList(this.workspaceId).subscribe((data: any) => {
           this.showTopRightLoader = false;
           this.sortedImagesList = data;
           this.mobileViewSection = false;
           this.mainSection = false;
           this.timelineSection = true;
           this.tableViewSection = false;
           this.tableViewData = false;
           this.folderViewSection = false;
           this.folderViewData = false;
           this.searchImageslistSection = false;
           for(var i = 0 ; i < this.sortedImagesList.length ; i++) {
             this.currentIllus = this.sortedImagesList[this.currentIllusPosition];
           }
           this.showAssetsRenameLoader = false;
           this.showTopRightLoader = false;
         });
       } else if(imgFrom == 'searchDialog') {
         this.damService.searchImagesArray(this.workspaceId, this.searchTerms).subscribe((data: any) => {
           this.searchText = "";
           this.imagesList = data.image;
           this.searchData = '' + this.searchTextSet;
           this.mobileViewSection = false;
           this.mainSection = false;
           this.timelineSection = false;
           this.tableViewSection = false;
           this.tableViewData = false;
           this.folderViewSection = false;
           this.folderViewData = false;
           this.searchImageslistSection = true;
           for(var i = 0 ; i < this.imagesList.length ; i++) {
             this.currentIllus = this.imagesList[this.currentSearchIllusPosition];
           }
           this.showAssetsRenameLoader = false;
         });
       }
       this.editImageNameBoardId = "";
     },
     (error: any) => {
       if(error.status == 403){
         this.showAssetsRenameLoader = false;
         this.renameErrorMsg = error.error.message;
       } else {
         this.showAssetsRenameLoader = false;
         this.renameErrorMsg = error.error.message;
       }
    });
   }


   editFavImageName(boardId: any){
     this.renameErrorMsg = "";
     this.favImageNameEdit = this.favImageHeading;
     this.editImageNameBoardId = boardId;
     this.showEditFavImageName = true;
     this.hideEditFavImageName = false;
     this.showEditImageName = false;
     this.hideEditImageName = false;
   }

   editFavImageNameApi(imgId: any, imgFrom: any){
     this.editNameDialogCloseScreen = imgFrom;
     this.showAssetsRenameLoader = true;
     this.damService.changeImageNameApi(this.workspaceId, this.editImageNameBoardId, imgId, this.favImageNameEdit).subscribe((data: any) => {
       this.showEditFavImageName = false;
       this.hideEditFavImageName = true;
       this.favImageHeading = data.title;
       this.showEditImageName = false;
       this.hideEditImageName = true;
       this.renameErrorMsg = "";
       if(imgFrom == 'regularDialog') {
         this.damService.getSortedImagesList(this.workspaceId).subscribe((data: any) => {
           this.showTopRightLoader = false;
           this.sortedImagesList = data;
           this.mobileViewSection = false;
           this.mainSection = false;
           this.timelineSection = true;
           this.tableViewSection = false;
           this.tableViewData = false;
           this.folderViewSection = false;
           this.folderViewData = false;
           this.searchImageslistSection = false;
           for(var i = 0 ; i < this.sortedImagesList.length ; i++) {
             this.currentIllus = this.sortedImagesList[this.currentIllusPosition];
           }
           this.showAssetsRenameLoader = false;
           this.showTopRightLoader = false;
         });
       } else if(imgFrom == 'searchDialog') {
         this.damService.searchImagesArray(this.workspaceId, this.searchTerms).subscribe((data: any) => {
           this.searchText = "";
           this.imagesList = data.image;
           this.searchData = '' + this.searchTextSet;
           this.mobileViewSection = false;
           this.mainSection = false;
           this.timelineSection = false;
           this.tableViewSection = false;
           this.tableViewData = false;
           this.folderViewSection = false;
           this.folderViewData = false;
           this.searchImageslistSection = true;
           for(var i = 0 ; i < this.imagesList.length ; i++) {
             this.currentIllus = this.imagesList[this.currentSearchIllusPosition];
           }
           this.showAssetsRenameLoader = false;
         });
       }
       this.editImageNameBoardId = "";
     },
     (error: any) => {
       if(error.status == 403){
         this.showAssetsRenameLoader = false;
         this.renameErrorMsg = error.error.message;
       } else {
         this.showAssetsRenameLoader = false;
         this.renameErrorMsg = error.error.message;
       }
    });
   }

   closeCashbackOffer() {
     this.cashbackOffersStyle = "none";
   }

   checkCashbackOffer() {
     this.cashbackOffersStyle = "none";
     this.router.navigate(['/dam/subscription']);
   }

   goProClick() {
     this.router.navigate(['/dam/subscription']);
   }

   favouriteImagesList = [];

   getFavImagesList(workspaceId: any) {
     this.damService.listFavouriteImages(workspaceId).subscribe((data: any) => {
       this.favouriteImagesList = data['results'];
     });
   }

   removeFavouriteImage(imageId: any, imageNameTitle: any, fromPos: any, fromWhichSection: any){
     this.damService.removeFavouriteImages(this.workspaceId, imageId, imageNameTitle).subscribe((data: any) => {
       if(fromPos == true) {
         this.damService.searchImagesArray(this.workspaceId, this.searchTerms).subscribe((data: any) => {
           this.searchText = "";
           this.showTopRightLoader = false;
           this.imagesList = data.image;
           this.searchData = '' + this.searchTextSet;
           this.mobileViewSection = false;
           this.mainSection = false;
           this.tableViewSection = false;
           this.tableViewData = false;
           this.timelineSection = false;
           this.folderViewSection = false;
           this.folderViewData = false;
           this.searchImageslistSection = true;
           for(var i = 0 ; i < this.imagesList.length ; i++) {
             this.currentIllus = this.imagesList[this.currentSearchIllusPosition];
           }
         });
       } else {
         if(fromWhichSection == 'timeline') {
           this.damService.getSortedImagesList(this.workspaceId).subscribe((data: any) => {
             this.showTopRightLoader = false;
             this.sortedImagesList = data;
             this.mobileViewSection = false;
             this.mainSection = false;
             this.timelineSection = true;
             this.tableViewSection = false;
             this.tableViewData = false;
             this.folderViewSection = false;
             this.folderViewData = false;
             this.searchImageslistSection = false;
             for(var i = 0 ; i < this.sortedImagesList.length ; i++) {
               this.currentIllus = this.sortedImagesList[this.currentIllusPosition];
             }
             this.showTopRightLoader = false;
           });
         } else if(fromWhichSection == 'search') {
           this.showTopRightLoader = false;
           this.searchArrayImages(this.searchText, this.searchTerms);
         } else if(fromWhichSection == 'table') {
           this.showTopRightLoader = false;
           this.getSortedImagesList();
         }
         this.getFavImagesList(this.workspaceId);
       }
     });
   }
}
